export enum AttendanceRequestCodes {
  ADDITIONAL_PERMANENT_ACCESS = 1,
  TEMPORARY_ACCESS,
  NO_PUNCH,
  LATE_PUNCH,
  TECHNICAL_ISSUE,
}
